import { useScript as _useScript, injectHead } from "@unhead/vue";
import { onNuxtReady, useNuxtApp } from "#imports";
export function useScript(input, options) {
  input = typeof input === "string" ? { src: input } : input;
  options = options || {};
  if (options.trigger === "onNuxtReady")
    options.trigger = onNuxtReady;
  const nuxtApp = useNuxtApp();
  const instance = _useScript(input, options);
  if (import.meta.dev && import.meta.client) {
    let syncScripts = function() {
      nuxtApp._scripts[instance.$script.id] = payload;
      nuxtApp.hooks.callHook("scripts:updated", { scripts: nuxtApp._scripts });
    };
    const payload = {
      key: input.key || input.src,
      src: input.src,
      $script: null,
      events: []
    };
    nuxtApp._scripts = nuxtApp._scripts || {};
    if (!nuxtApp._scripts[instance.$script.id]) {
      const head = injectHead();
      head.hooks.hook("script:updated", (ctx) => {
        if (ctx.script.id !== instance.$script.id)
          return;
        payload.events.push({
          type: "status",
          status: ctx.script.status,
          at: Date.now()
        });
        payload.$script = instance.$script;
        syncScripts();
      });
      head.hooks.hook("script:instance-fn", (ctx) => {
        if (ctx.script.id !== instance.$script.id)
          return;
        payload.events.push({
          type: "fn-call",
          fn: ctx.fn,
          args: ctx.args,
          at: Date.now()
        });
        syncScripts();
      });
      payload.$script = instance.$script;
      payload.events.push({
        type: "status",
        status: "awaitingLoad",
        trigger: options?.trigger,
        at: Date.now()
      });
      syncScripts();
    }
  }
  return instance;
}
